import React from 'react';
import styled, { keyframes } from 'styled-components';

const FooterContainer = styled.footer`
  position: relative;
  width: 100%;
  background: #3586ff;
  min-height: 100px;
  padding: 20px 5%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const List = styled.ul`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0;
  flex-wrap: wrap;
`;

const ListItem = styled.li`
  list-style: none;
`;

const Link = styled.a`
  font-size: ${({ size }) => size || '1.2rem'};
  color: #fff;
  margin: 0 10px;
  display: inline-block;
  transition: 0.5s;
  text-decoration: none;
  opacity: 0.75;
  font-weight: 300;

  &:hover {
    opacity: 1;
    transform: translateY(-10px);
  }
`;

const Paragraph = styled.p`
  color: #fff;
  margin: 15px 0 10px 0;
  font-size: 1.5rem;
  font-weight: 800;
`;

const waveAnimation = keyframes`
  0% {
    background-position-x: 1000px;
  }
  100% {
    background-position-x: 0px;
  }
`;

const Wave = styled.div`
  position: absolute;
  top: -100px;
  left: 0;
  width: 100%;
  height: 100px;
  background: url("https://i.ibb.co/wQZVxxk/wave.png");
  background-size: 1000px 100px;
`;

const FirstWave = styled(Wave)`
  z-index: 1000;
  opacity: 1;
  bottom: 0;
  animation: ${waveAnimation} 4s linear infinite;
`;

const SecondWave = styled(Wave)`
  z-index: 999;
  opacity: 0.5;
  bottom: 10px;
  animation: ${waveAnimation} 4s linear infinite;
`;

const ThirdWave = styled(Wave)`
  z-index: 1000;
  opacity: 0.2;
  bottom: 15px;
  animation: ${waveAnimation} 3s linear infinite;
`;

const FourthWave = styled(Wave)`
  z-index: 999;
  opacity: 0.7;
  bottom: 20px;
  animation: ${waveAnimation} 3s linear infinite;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <div className="waves">
        <FirstWave id="wave1" />
        <SecondWave id="wave2" />
        <ThirdWave id="wave3" />
        <FourthWave id="wave4" />
      </div>
      <List className="social-icon">
        <ListItem className="social-icon__item">
          <Link className="social-icon__link" href="#">
            <ion-icon name="logo-facebook"></ion-icon>
          </Link>
        </ListItem>
        <ListItem className="social-icon__item">
          <Link className="social-icon__link" href="#">
            <ion-icon name="logo-twitter"></ion-icon>
          </Link>
        </ListItem>
        <ListItem className="social-icon__item">
          <Link className="social-icon__link" href="#">
            <ion-icon name="logo-linkedin"></ion-icon>
          </Link>
        </ListItem>
        <ListItem className="social-icon__item">
          <Link className="social-icon__link" href="#">
            <ion-icon name="logo-instagram"></ion-icon>
          </Link>
        </ListItem>
      </List>
      <List className="menu">
        <ListItem className="menu__item">
          <Link className="menu__link" to="/">
            Home
          </Link>
        </ListItem>
        <ListItem className="menu__item">
          <Link className="menu__link" to="/abt">
            About
          </Link>
        </ListItem>
        <a href="https://www.facebook.com/profile.php?id=100086642529053">
          <i className="fa-brands fa-facebook" style={{ fontSize: '30px', color: 'black', marginLeft: '5px' }}></i>
        </a>
        <a href="https://www.instagram.com/itx_sahil1110?igsh=MXc4M2xqNXlkOGVNw==">
          <i className="fa-brands fa-instagram" style={{ fontSize: '30px', color: 'black', marginLeft: '5px' }}></i>
        </a>
      </List>
      <h3 style={{ fontWeight: '800', color: 'white' }}>Contacts: </h3>
      <h5>Gmail: <code>Sahilminecraft502@gmail.com</code></h5>
      <Paragraph>&copy;2024 ItxSahil Website | All Rights Reserved</Paragraph>
    </FooterContainer>
  );
};

export default Footer;
